import React from "react";

import { useSelector, useDispatch } from "react-redux";
import {
  setFilterOption,
  clearFilter,
  applyFilters,
  selectFilterOptions,
} from "../../../feature/dashboardFilter/receivingDashboardFilterSlice";
const DashBoardFilter = ({ isActive, handlePreviewClick }) => {
  const dispatch = useDispatch();
  const filterOptions = useSelector(selectFilterOptions);
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    dispatch(setFilterOption({ name, value }));
  };

  const handleClearFilter = () => {
    dispatch(clearFilter());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(applyFilters());
    handlePreviewClick && handlePreviewClick();
  };

  return (
    <div className={isActive ? "filter-div active" : "filter-div"}>
      <div className="d-flex justify-content-between">
        <h4 className="heading-filter">Filter</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-floating mb-2">
          <input
            name="receving_date_from"
            type="date"
            className="form-control"
            id="floatingInput"
            value={filterOptions?.receving_date_from}
            onChange={handleFilterChange}
          />
          <label htmlFor="floatingInput">Entry Date (FROM)</label>
        </div>

        <div className="form-floating mb-2">
          <input
            name="receving_date_to"
            type="date"
            className="form-control"
            id="floatingInput"
            value={filterOptions?.receving_date_to}
            onChange={handleFilterChange}
          />
          <label htmlFor="floatingInput">Entry Date (TO)</label>
        </div>
        <div className="d-flex justify-content-around">
          <div className="form-floating text-center">
            <input
              type="submit"
              value="Preview"
              className="btn-filter-theme border-0 m-auto"
            />
          </div>
          <div className="form-floating text-center">
            <input
              type="button"
              value="Clear Filter"
              className="btn-filter-theme border-0 m-auto"
              onClick={handleClearFilter}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default DashBoardFilter;
